import { apiClient } from '../../common/ApiClient';
import { expand } from 'uri-template-lite';
import {
  InputDataDetailsKey,
  SampleCommentType,
  SampleCommentValidFormDataType,
} from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import {
  SampleCommentMutationDtoSchema,
  SampleCommentsSchema,
} from '../schema/SampleCommentSchema';

export interface InputDataDetailsCommentUpdate {
  params: InputDataDetailsKey;
  comment: SampleCommentValidFormDataType;
}

const postInputDataDetailsComment = (
  params: InputDataDetailsCommentUpdate,
  headers?: HttpHeaders,
): Promise<SampleCommentType> =>
  apiClient
    .post<SampleCommentType>(
      expand(InputDataUrl.INPUT_DATA_DETAILS_COMMENTS, params.params),
      SampleCommentMutationDtoSchema.parse(params.comment),
      headers ? { headers } : undefined,
    )
    .then((response) => SampleCommentsSchema.parse(response.data));

export const useInputDataDetailsCommentMutation = createApiMutationHook(
  ['inputDataDetailsCommentMutation'],
  getMutationFn(postInputDataDetailsComment),
);
